import { render } from "./CatalogProductPreview.vue?vue&type=template&id=35984e1b"
import script from "./CatalogProductPreview.vue?vue&type=script&lang=js"
export * from "./CatalogProductPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__